export const BLOG_LOCALE = "en";
export const ENGLISH_ONLY_CONTENT_ROOT_PATHS = [
  "/guides",
  "/learn",
  "/news",
  "/blog",
  "/openings",
];

export function isEnglishOnlyContentPath(path: string) {
  return ENGLISH_ONLY_CONTENT_ROOT_PATHS.some(
    (rootPath) => path === rootPath || path.startsWith(`${rootPath}/`),
  );
}

export const isEnglishOnlyBlogPath = isEnglishOnlyContentPath;
